import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { MessageContext } from '../context/MessageContext';
import Icons from '../components/Icons';

function Profile() {
  const { user, serverNotAvailable, loading: authLoading } = useContext(AuthContext);
  const { setMess } = useContext(MessageContext);
  const [managerData, setManagerData] = useState(null);

  useEffect(() => {
    const fetchManagerData = async () => {
      if (!user?.email) return;
      try {
        const response = await axios.get(`/api/managers/${user.email}`);
        setManagerData(response.data);
      } catch (err) {
        setMess({ color: 'red', title: 'Ошибка:', desc: `Ошибка загрузки данных менеджера: ${err.message}` });
      }
    };
    if (!authLoading && user) fetchManagerData();
  }, [user, authLoading, setMess]);

  // Сообщение "Сервер не доступен"
  if (serverNotAvailable) return (
    <section className="py-10">
      <div className="flex justify-center px-4">
        <div className="flex w-full max-w-md bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-center w-12 bg-yellow-500">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="px-4 py-3">
            <div className="flex flex-col">
              <span className="textyellow-500 dark:text-yellow-400">Ошибка загрузки данных</span>
              <p className="text-sm text-gray-600 dark:text-gray-200">
                Сервер не доступен
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  if (authLoading) return (<div className="flex justify-center p-4"><Icons name="Spinner" /> </div>);

  if (!user) return (
    <section className="py-10">
      <div className="flex justify-center px-4">
        <div className="flex w-full max-w-md bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-center w-12 bg-green-500">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="px-4 py-3">
            <div className="flex flex-col">
              <span className="text-green-500 dark:text-green-400">Требуется авторизация</span>
              <p className="text-sm text-gray-600 dark:text-gray-200">
                Пожалуйста, войдите в систему, чтобы продолжить.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  return (
    <section className="py-10 px-4 flex flex-col items-center">
      <div className="max-w-xl w-full bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
        <h2 className="text-xl mb-4 text-green-600 dark:text-green-400">Профиль менеджера</h2>
        {managerData ? (
          <div className="space-y-4">
            <p><strong className="text-gray-700 dark:text-gray-400">Имя:</strong> {managerData.name || 'Не указано'}</p>
            <p><strong className="text-gray-700 dark:text-gray-400">Логин:</strong> {managerData.login || 'Не указано'}</p>
            <p><strong className="text-gray-700 dark:text-gray-400">Email:</strong> {managerData.email || 'Не указано'}</p>
            <p><strong className="text-gray-700 dark:text-gray-400">Город:</strong> {managerData.city || 'Не указано'}</p>
            <p><strong className="text-gray-700 dark:text-gray-400">Кол-во предложений:</strong> {managerData.offers_done || 'Не указано'}</p>
            <p><strong className="text-gray-700 dark:text-gray-400">Кол-во сделок:</strong> {managerData.deals_done || 'Не указано'}</p>
          </div>
        ) : (
          <p className="text-gray-600 dark:text-gray-400">Данные менеджера отсутствуют</p>
        )}
      </div>
    </section>
  );
}

export default Profile;